'use client';

import { isProductionLike } from '#/constants/env';

export default function getSsoBaseUrl() {
  return isProductionLike
    ? 'https://sso.rockx.com'
    : 'https://beta-sso.rockx.com';
}
